// extracted by mini-css-extract-plugin
module.exports = {"content":"Statements_content__3r1HD","text":"Statements_text__3qxy7"};